// @ts-nocheck
<template>
  <div>
    <div v-for="item in linksList" :key="item.title">
      <q-item
        clickable
        @click="link = item.title"
        v-ripple
        :disable="item.isDisabled"
        :class="{ 'my-menu-link': link === item.title }"
        active-class="my-menu-link"
        :active="link === item.title"
        :to="item.link"
      >
        <q-item-section avatar class="items-center col-12">
          <q-icon :name="item.icon" />
          <q-item-label>{{ item.title }}</q-item-label>
        </q-item-section>
      </q-item>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onBeforeUnmount, onMounted, computed, watch } from "vue";
// import type { MainMenu } from '../models/mainMenu.model';
import { MenuLabel, MenuIcon } from "./menu.model";
import {
  // searchStatus,
  searchStatusJustification,
  searchStatusProjectStatusJustificat,
  searchStSecondPhaseOrJustification,
  searchStatusProjectStatusImpacte
} from "../../../micro-vue3-memoria/src/models/statusProject";

export default defineComponent({
  props: {
    state: {
      type: String,
      default: "",
    },
    projectId: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    // const store = useStore();
    // Getting projectId and form id from URL
    let url = window.location.pathname;
    let ypid = url.match(/\/(?:.(?!\/))+$/);
    let zpid = ypid[0]?.substring(1);
    let yform = url.match(/form\d+/);

    localStorage.setItem("projectId", zpid);

    const link = ref(MenuLabel.memory);
    const linksList = ref([]);

    onMounted(() => {
      getList();
      console.log("MOUNTED", props.state);
    });

    watch(
      () => props.state,
      () => {
        getList();
        console.log("watch", props.state);
      }
    );

    // const isStateInSecondPhase = computed(() => {
    //   return searchStatus(props.state);
    // });

    const isStateInJustificationPhase = computed(() => {
      return searchStatusJustification(props.state);
    });

    const isStateJustificatOrFinalitzat = computed(() => {
      return props.state === "Justificat" || props.state === "Finalitzat";
    });

    const isStateInSecondPhaseOrJustification = computed(() => {
      return searchStSecondPhaseOrJustification(props.state);
    });

    const isStateProjectStatusJustificat = computed(() => {
      return searchStatusProjectStatusJustificat(props.state);
    });

    const isStateProjectStatusImpacte = computed(() => {
      return searchStatusProjectStatusImpacte(props.state);
    });

    const getList = () => {
      linksList.value = [
        {
          title: MenuLabel.memory,
          icon: MenuIcon.memory,
          isDisabled: false,
          link: `/plist/projecte${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_MEMORIA}/${yform}/${zpid}`,
        },
        {
          title: MenuLabel.execusio,
          icon: MenuIcon.execusio,
          isDisabled: !isStateInSecondPhaseOrJustification.value && !isStateJustificatOrFinalitzat.value,
          link: `/plist/projecte${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_EXECUCIO}`,
        },
        {
          title: MenuLabel.justificacio_tecnica,
          icon: MenuIcon.justificacio_tecnica,
          // TODO to show this app (false)
          isDisabled: !isStateInJustificationPhase.value,
          // isDisabled: !isStateInSecondPhaseOrJustification.value,
          link: `/plist/projecte${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_JUSTIFICACIO_TECNICA}`,
        },
        {
          title: MenuLabel.justificacio_economica,
          icon: MenuIcon.justificacio_economica,
          // TODO to show this app (false)
          isDisabled: !isStateInJustificationPhase.value,
          // isDisabled:
          //   !isStateInJustificationPhase.value &&
          //   !isStateJustificatOrFinalitzat.value,

          link: `/plist/projecte${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_JUSTIFICACIO_ECONOMICA}`,
        },
        {
          title: MenuLabel.finalitzar,
          icon: MenuIcon.finalitzar,
          isDisabled: !isStateProjectStatusJustificat.value,
          link: `/plist/projecte${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_FINALITZAR}`,
        },
        {
          title: MenuLabel.impacte,
          icon: MenuIcon.impacte,
          isDisabled: !isStateProjectStatusImpacte.value,
          link: `/plist/projecte${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_IMPACTE}`,
        },
      ];
    };

    onBeforeUnmount(() => {
      sessionStorage.removeItem("dataHeader");
      sessionStorage.clear();
      linksList.value = [];
    });

    return {
      linksList,
      link,
    };
  },
});
</script>
<style lang="scss">
.my-menu-link {
  background: #fafafaef;
  position: relative !important;
  color: #f44336 !important;
}
</style>
